import { MeetingMinutesData } from "./MeetingMinutesForm.schema";

/**
 * Flatten MeetingMinutesData into the Form.io key naming convention expected
 * by the document producer backend.
 */
export function flattenMeetingMinutes(
  data: MeetingMinutesData
): Record<string, unknown> {
  const flat: Record<string, unknown> = {
    docRefMeetPlace: data.docRefMeetPlace,
    docRefMeetDate: data.docRefMeetDate,
    docRefMeetPart: data.docRefMeetPart,
    docRefDet: data.docRefDet,
    dpOtherCases: data.otherCases,
  };

  data.tasks.forEach((row: MeetingMinutesData["tasks"][number], i: number) => {
    const n = i + 1;
    flat[`dpmeetDotf${n}`] = row.task;
    flat[`dpmeetDoOwnertf${n}`] = row.owner;
    flat[`dpmeetDoDeadline${n}`] = row.deadline;
    flat[`dpmeetDoStatus${n}`] = row.status;
  });

  return flat;
}
